import {create} from 'zustand';

const useShoppingKartStore = create((set, get) => ({
    shoppingKart: JSON.parse(localStorage.getItem('kart')) || [],
    addToKart: (data) => {
        const tempShoppingKart = get().shoppingKart
        const kartItemIndex = tempShoppingKart.findIndex(el => el.id === data.id)
        if(kartItemIndex != -1){
            tempShoppingKart[kartItemIndex].qty += 1
            set(() => ({
                shoppingKart: [...tempShoppingKart]
            }))
        } else{
            data.qty = 1
            set((state) => ({
                shoppingKart: [...state.shoppingKart, data]
            }))
        }
        localStorage.setItem('kart', JSON.stringify(get().shoppingKart))
    },
    deleteFromKart: (data) => {
        const tempShoppingKart = get().shoppingKart
        const kartItemIndex = tempShoppingKart.findIndex(el => el.id === data.id)
        if(tempShoppingKart[kartItemIndex].qty > 1){
            tempShoppingKart[kartItemIndex].qty -= 1
            set(() => ({
                shoppingKart: [...tempShoppingKart]
            }))
        } else{
            set((state) => ({
                shoppingKart: [...state.shoppingKart.filter(el => el.id !== data.id)]
            }))
        }
        localStorage.setItem('kart', JSON.stringify(get().shoppingKart))
    }
}))

export default useShoppingKartStore;